import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const VerifoneBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.VERIFON}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.VERIFON)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.VERIFON)} alt="verifone" />
    </Box>
  );
};
